import React from "react"
import PropTypes from "prop-types"

const ProductTabs = ({ products, tabActive, onChangeTab, children }) => (
  <div className="av-anim">
    <div className="av-tabs">
      {products.map((product, index) => (
        <button
          key={product.id}
          type="button"
          className={index === tabActive ? "is-on" : ""}
          onClick={() => onChangeTab(index)}
        >
          {product.name}
        </button>
      ))}
    </div>
    <div className="av-tabs-body">{children}</div>
  </div>
)

ProductTabs.propTypes = {
  products: PropTypes.array.isRequired,
  tabActive: PropTypes.number.isRequired,
  onChangeTab: PropTypes.func.isRequired,
  children: PropTypes.any,
}

export default ProductTabs
